<template>
  <div>
    <div v-show="showMasonry" v-masonry gutter="15" transition-duration="0s" item-selector=".item">
      <div v-bind:key="index" v-masonry-tile class="item wc"
           v-for="(tweet, index) in tweets">
        <tweet :id="tweet._id" error-message=""/>
      </div>
    </div>
    <ptwist-loading text="Waiting for tweets to render..." v-show="!showMasonry"></ptwist-loading>
  </div>
</template>
<script>
import imagesLoaded from 'vue-images-loaded'
import { Tweet } from 'vue-tweet-embed'

export default {
  data: () => ({
    showMasonry: false
  }),
  mounted () {
    setTimeout(() => {
      this.showMasonry = true
    }, 6000)
  },
  methods: {},
  name: 'wc-top-tweets-masonry',

  components: { 'tweet': Tweet },
  directives: {
    imagesLoaded
  },
  props: {
    tweets: {
      type: Array,
      description: 'Tweets for the masonry grid'
    }
  },
  filters: {
    toString (tweetId) {
      return String(tweetId)
    }
  },
  created () {
    setInterval(() => this.$redrawVueMasonry(), 500)
  }
}
</script>
<style lang="sass">
  .wc
    .twitter-tweet
      max-width: 19.5rem !important
</style>
